<nav class="nav">
  @for (tab of tabs(); track tab.index) {
    <div
      #tab
      class="tab"
      [class.inline]="tab?.preIcon || tab?.postIcon"
      [class.active]="i() === tab.index"
      [class.disabled]="tab.disabled"
      [class.unread]="tab.unread"
      [attr.data-test]="'tab_' + tab.index"
      (click)="setActiveTab($event, tab)">
      @if (tab?.preIcon) {
        <pu-icon
          [iconName]="tab?.preIcon"
          [size]="tab?.iconSize ?? DEFAULT_ICON_SIZE" />
      }
      {{ tab.key | translate }}
      @if (tab?.postIcon) {
        <pu-icon
          [iconName]="tab?.postIcon"
          [size]="tab?.iconSize ?? DEFAULT_ICON_SIZE" />
      }

      @if (tab.tooltip) {
        <pp-tooltip [text]="tab.tooltip | translate" [customContent]="true">
          <div class="tooltip"></div>
        </pp-tooltip>
      }
    </div>
  }
  <div [style.left.px]="x" [style.width.px]="stickWidth" class="stick"></div>
</nav>
